import { css } from '@emotion/react';
import { Z_INDEX } from '../../constants/zIndex';
import { SIDE_BAR_WIDTH } from '../../constants/sideBarWidth';

export const locationsListStyles = {
    desktopWrapper: css({
        height: 'calc(100vh - 64px)',
        width: `${SIDE_BAR_WIDTH}px`,
        position: 'fixed',
        top: '32px',
        left: '32px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        padding: '10px 0 6px',
        zIndex: Z_INDEX.LOCATIONS_LIST,
        overflow: 'hidden',

        '@media (min-width: 600px)': {
            height: 'calc(100vh - 134px)',
        },
    }),
    list: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0px 16px 30px 16px',
        width: '100%',
        boxSizing: 'border-box',
        overflowY: 'auto',
    }),
    loadingBlock: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '15px 16px 20px 16px',
        width: '100%',
        height: '180px',
        boxSizing: 'border-box',
        fontSize: '20px',
        lineHeight: '24px',
        fontWeight: 700,
    }),
    skeletonLoadingBlock: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '15px 16px 20px 16px',
        width: '100%',
        boxSizing: 'border-box',
    }),
    root: css({
        position: 'relative',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),
};
